<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add a Company</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">
          <div class="field">
            <label class="label">Company Name*</label>
            <v-text-field 
              required
              placeholder="Enter Company Name"
              v-model="company.name">
            </v-text-field>
          </div>
          <div class="field">
            <label class="label">Address*</label>
            <v-text-field 
              required
              placeholder="Enter Company Address"
              v-model="company.address">
            </v-text-field>
          </div>
          <div class="field">
            <label class="label">City*</label>
            <v-text-field 
              required
              placeholder="Enter City"
              v-model="company.city">
            </v-text-field>
          </div>
          <div class="field">
            <label class="label">Postal Code*</label>
            <v-text-field
              required 
              placeholder="Enter Postal Code"
              v-model="company.postalcode">
            </v-text-field>
          </div>
          <div class="field">
            <label class="label">Province*</label>
            <v-text-field 
              required
              placeholder="Enter Province"
              v-model="company.province">
            </v-text-field>
          </div>
          <div class="field">
            <label class="label">Country*</label>
            <v-text-field 
              required
              placeholder="Enter Country"
              v-model="company.country">
            </v-text-field>
          </div>
          <div class="field">
            <label class="label">Phone Number*</label>
            <v-text-field 
              required
              placeholder="Enter Phone Number"
              v-model="company.phone1">
            </v-text-field>
          </div>
          <div class="field">
            <div class="label-and-button pb-2">
              <label class="label mb-0">Company Category*</label>
              <span 
                class="tag pointer" 
                @click="managingCategories = true">
                <span class="icon is-small">
                  <i class="fas fa-plus"></i>
                </span>
                <span>Manage Categories</span>
              </span>
            </div>
            <v-select 
              required
              :options="categories"
              item-text="category"
              item-value="id"
              v-model="company.category_id"
            />
          </div>
        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addNewCompany()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

    <manage-categories-modal 
      v-model="managingCategories"/>
  </div>
</template>

<script>
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'
import ManageCategoriesModal from '@/components/ticketing/ManageCategoriesModal'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { VTextField, VForm, VSelect, ManageCategoriesModal },
  data() {
    return {
      company: {
        name: '',
        address: '',
        city: '',
        postalcode: '',
        province: '',
        country: '',
        phone1: '',
        category_id: ''
      },
      valid: false,
      managingCategories: false
    }
  },
  computed: {
    ...mapState("tickets", ["categories"])
  },
  methods: {
    ...mapActions("tickets", ["addCompany"]),
    addNewCompany() {
      this.addCompany(this.company).then(() => {
        this.close(true);
      })
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
.label-and-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .tag {
    cursor: pointer;
    &:hover {
      background: gainsboro;
    }
  }
}
</style>
